interface StepDotsProps {
  total: number;
  currentIndex: number;
}

/** Dot indicator for the wizard shell; one per step, spread across the card width. */
export default function StepDots({ total, currentIndex }: StepDotsProps) {
  if (total <= 0) return null;

  return (
    <div className="ob-dots-row" aria-hidden>
      <div className="ob-dots-compact">
        {Array.from({ length: total }).map((_, i) => {
          let state: 'completed' | 'active' | 'inactive';
          if (i < currentIndex) state = 'completed';
          else if (i === currentIndex) state = 'active';
          else state = 'inactive';
          return <span key={i} className={`ob-dot-mini ${state}`} />;
        })}
      </div>
    </div>
  );
}
